import type { TradeOrder } from '../reducer/strategyBuilder.reducer'

/** Passed via `navigate(..., { state })` from positions flows; consumed on Strategy Builder mount/sync. */
export const STRATEGY_BUILDER_LOCATION_PENDING_KEY = 'pendingStrategyBuilderFromPositions' as const

export type StrategyBuilderLocationPending =
    | { kind: 'analyze'; basketId: string; strategyGroup: string; batchId: string }
    | { kind: 'squareOff'; basketId: string; strategyGroup: string; batchId: string; orders: TradeOrder[] }

export type StrategyBuilderLocationState = {
    [STRATEGY_BUILDER_LOCATION_PENDING_KEY]?: StrategyBuilderLocationPending
}
